import React, { useState, useEffect } from "react";
import "../App.css";
import axios from "axios";
import Sidebar from "../componenteExtra/SidebarAdmin";
import Modal from "react-modal";
import { Toaster } from "react-hot-toast";
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement("#root");

const Seniors = () => {
  const [seniorList, setSeniorList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSenior, setSelectedSenior] = useState(null);
  const [modalAgregarSenior, setModalAgregarSenior] = useState(false);
  const [nuevoNombreSenior, setNuevoNombreSenior] = useState("");
  const [modalDesactivarSenior, setModalDesactivarSenior] = useState(false);
  const [approvalPendingActivities, setApprovalPendingActivities] = useState(
    [],
  );
  const [approvalPendingModalIsOpen, setApprovalPendingModalIsOpen] =
    useState(false);

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    // Actualizar los conteos de actividades en espera de aprobación para los seniors
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/update_approval_pending_counts_senior`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        console.log(
          "Conteos de actividades en espera de aprobación actualizados:",
          response.data,
        );
        fetchSeniors(); // Llama a fetchSeniors para obtener la lista actualizada de seniors
      })
      .catch((error) =>
        console.error("Error al actualizar conteos de actividades:", error),
      );
  }, [token]);

  const fetchSeniors = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/get_all_seniors2`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setSeniorList(response.data);
      })
      .catch((error) => console.error("Error fetching seniors:", error));
  };

  const openApprovalPendingModal = (seniorId) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/activities_pending_approval_senior/${seniorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        console.log(response.data); // Verifica si los datos están llegando aquí
        setApprovalPendingActivities(response.data);
        setSelectedSenior(seniorId);
        setApprovalPendingModalIsOpen(true);
      })
      .catch((error) =>
        console.error("Error fetching approval pending activities:", error),
      );
  };

  const closeApprovalPendingModal = () => {
    setApprovalPendingModalIsOpen(false);
    setApprovalPendingActivities([]);
  };

  const getRiskIndicatorColor = (fechaDocumentacion, fechaTermino) => {
    const today = new Date();
    const endDate = new Date(fechaTermino);

    const diffTime = endDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays >= 5) {
      return "green";
    } else if (diffDays > 3) {
      return "yellow";
    } else {
      return "red";
    }
  };

  const handleAgregarSenior = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/agregar_senior_get`, {
        nombre_senior_get: nuevoNombreSenior,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setModalAgregarSenior(false);
      setNuevoNombreSenior("");
      fetchSeniors();
    } catch (error) {
      console.error("Error al agregar senior:", error);
    }
  };

  const handleDesactivarSenior = async () => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/desactivar_senior_get`, {
        id: selectedSenior,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setModalDesactivarSenior(false);
      fetchSeniors();
    } catch (error) {
      console.error("Error al desactivar senior:", error);
    }
  };

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Seniors GET</h1>
          <div className="filter-section">
            <label htmlFor="searchTerm">Buscar por nombre del Senior: </label>
            <input
              type="text"
              id="searchTerm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="button-container">
              <button onClick={() => setModalAgregarSenior(true)} className="add-user-btn">➕ Agregar Senior</button>
            </div>
          </div>
          <div className="activities-table-container">
            <table className="activities-table">
              <thead>
                <tr>
                  <th>Estado</th>
                  <th>Nombre Senior GET</th>
                  <th>Actividades en Espera de Aprobación</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {seniorList
                  .filter((senior) =>
                    senior.nombre_senior_get
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()),
                  )
                  .map((senior, index) => (
                    <tr key={index}>
                      <td>
                        <span className={senior.estado === 'activo' ? 'estado-activo' : 'estado-inactivo'}>
                          {senior.estado}
                        </span>
                      </td>
                      <td>{senior.nombre_senior_get}</td>
                      <td>
                        {senior.espera_aprobacion}
                        {senior.espera_aprobacion > 0 && (
                          <button
                            onClick={() => openApprovalPendingModal(senior.id)}
                            style={{
                              marginLeft: "10px",
                              backgroundColor: "yellow",
                              color: "black",
                            }}
                          >
                            Ver
                          </button>
                        )}
                      </td>
                      <td>
                      <button
                        onClick={() => {
                          setSelectedSenior(senior.id);
                          setModalDesactivarSenior(true);
                        }} className="delete-button">🚫Desactivar
                      </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Modal isOpen={modalAgregarSenior} onRequestClose={() => setModalAgregarSenior(false)} className="modal-content" overlayClassName="modal-overlay">
        <h2>Agregar Senior</h2>
        <input
          type="text"
          placeholder="Nombre del Senior"
          value={nuevoNombreSenior}
          onChange={(e) => setNuevoNombreSenior(e.target.value)}
        />
        <button onClick={handleAgregarSenior}className="submit-button">Agregar</button>
        <button onClick={() => setModalAgregarSenior(false)}className="close-button">Atrás</button>
      </Modal>

      <Modal isOpen={modalDesactivarSenior} onRequestClose={() => setModalDesactivarSenior(false)} className="modal-content" overlayClassName="modal-overlay">
        <h2>¿Estás seguro de que quieres desactivar este senior?</h2>
        <button onClick={handleDesactivarSenior}className="deactivate-button">Sí, desactivar</button>
        <button onClick={() => setModalDesactivarSenior(false)}className="back-button">Atrás</button>
      </Modal>
      <Toaster />
    </div>
  );
};

export default Seniors;
